import { useQuery, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(process.env.GATSBY_GRAPHQL_ENDPOINT as string, {
    method: "POST",
    ...({ credentials: 'include', headers: { 'Content-Type': 'application/json' } }),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum ActiveEventTab {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type BlockAttachments = {
  __typename?: 'BlockAttachments';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  items: Maybe<Array<Maybe<BlockDocument>>>;
};

export type BlockCompaniesList = {
  __typename?: 'BlockCompaniesList';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  displayName: Scalars['String'];
  viewName: Scalars['String'];
};

export type BlockCookiePreferencesButton = {
  __typename?: 'BlockCookiePreferencesButton';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  buttonText: Maybe<Scalars['String']>;
};

export type BlockDocument = {
  __typename?: 'BlockDocument';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  caption: Scalars['String'];
  filemime: Scalars['String'];
  size: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BlockForm = {
  __typename?: 'BlockForm';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  id: Scalars['String'];
};

export type BlockHighlight = {
  __typename?: 'BlockHighlight';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  highlightContent: Maybe<Array<ContentBlockHighlight>>;
  highlightTitle: Maybe<Scalars['String']>;
};

export type BlockHtml = {
  __typename?: 'BlockHtml';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  html: Scalars['String'];
};

export type BlockIframe = {
  __typename?: 'BlockIframe';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  url: Scalars['String'];
};

export type BlockImage = {
  __typename?: 'BlockImage';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  caption: Scalars['String'];
  image: Image;
  source: Scalars['String'];
};

export type BlockInfoBox = {
  __typename?: 'BlockInfoBox';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  boxContent: Scalars['String'];
  boxHeading: Maybe<Scalars['String']>;
  boxImage: Maybe<BlockImage>;
};

export type BlockLinkList = {
  __typename?: 'BlockLinkList';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  items: Array<LinkListItem>;
};

export type BlockPodcast = {
  __typename?: 'BlockPodcast';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  caption: Scalars['String'];
  embedUrl: Scalars['String'];
  provider: Scalars['String'];
  title: Scalars['String'];
};

export type BlockPodcastButtons = {
  __typename?: 'BlockPodcastButtons';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  appleUrl: Maybe<Scalars['String']>;
  spotifyUrl: Maybe<Scalars['String']>;
};

export type BlockRemoteVideo = {
  __typename?: 'BlockRemoteVideo';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  embedUrl: Scalars['String'];
  title: Scalars['String'];
};

export type BlockTeaserList = {
  __typename?: 'BlockTeaserList';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  items: Array<BlockTeaserListItem>;
};

export type BlockTeaserListItem = {
  __typename?: 'BlockTeaserListItem';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  descriptionHtml: Maybe<Scalars['String']>;
  subtitleHtml: Maybe<Scalars['String']>;
  teaserImage: Maybe<Image>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type Branch = {
  __typename?: 'Branch';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Branch>;
  depth: Scalars['Int'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  langcode: Scalars['String'];
  title: Scalars['String'];
  translations: Array<Branch>;
};

export type Bulletin = {
  __typename?: 'Bulletin';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Bulletin>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<Bulletin>;
  video: Maybe<BlockRemoteVideo>;
};

export type ChildCompanyBranch = {
  __typename?: 'ChildCompanyBranch';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  term: Maybe<Branch>;
};

export type CompaniesListInput = {
  filters: InputMaybe<CompaniesListInputFilter>;
  itemsPerPage: Scalars['Int'];
  langcode: Scalars['String'];
  page: Scalars['Int'];
};

export type CompaniesListInputFilter = {
  branch: InputMaybe<Array<Scalars['String']>>;
  title: InputMaybe<Scalars['String']>;
};

export type CompaniesListResult = {
  __typename?: 'CompaniesListResult';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  content: Array<Company>;
  total: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Company>;
  addition: Maybe<Scalars['String']>;
  address: Maybe<Scalars['String']>;
  branches: Maybe<Array<CompanyBranch>>;
  city: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  contactEmail: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  langcode: Scalars['String'];
  logo: Maybe<Image>;
  member: Maybe<Scalars['Boolean']>;
  modifiedTimestamp: Scalars['String'];
  otherAddresses: Maybe<Scalars['String']>;
  path: Scalars['String'];
  poBox: Maybe<Scalars['String']>;
  title: Scalars['String'];
  translations: Array<Company>;
  websiteLinkTitle: Maybe<Scalars['String']>;
  websiteLinkUrl: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

export type CompanyBranch = {
  __typename?: 'CompanyBranch';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  term: Maybe<Branch>;
  termChildren: Maybe<Array<ChildCompanyBranch>>;
};

export type ContentBlock = BlockCompaniesList | BlockCookiePreferencesButton | BlockDocument | BlockForm | BlockHighlight | BlockHtml | BlockIframe | BlockImage | BlockInfoBox | BlockLinkList | BlockPodcast | BlockPodcastButtons | BlockRemoteVideo | BlockTeaserList;

export type ContentBlockHighlight = BlockCompaniesList | BlockCookiePreferencesButton | BlockDocument | BlockForm | BlockHtml | BlockIframe | BlockImage | BlockInfoBox | BlockLinkList | BlockPodcast | BlockRemoteVideo;

export type ContentHubFocusListInput = {
  filters: InputMaybe<ContentHubFocusListInputFilter>;
  itemsNumber: Scalars['Int'];
  langcode: Scalars['String'];
};

export type ContentHubFocusListInputFilter = {
  topics: InputMaybe<Array<Scalars['String']>>;
};

export type ContentHubFocusListResult = {
  __typename?: 'ContentHubFocusListResult';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  content: Array<ContentHubListResultItem>;
  total: Scalars['Int'];
};

export type ContentHubListInput = {
  filters: InputMaybe<ContentHubListInputFilter>;
  ignoreFirstHeroContent: InputMaybe<Scalars['Boolean']>;
  itemsPerPage: Scalars['Int'];
  langcode: Scalars['String'];
  page: Scalars['Int'];
  stickySort: InputMaybe<Scalars['Boolean']>;
};

export type ContentHubListInputFilter = {
  activeTab: InputMaybe<ActiveEventTab>;
  endDate: InputMaybe<Scalars['String']>;
  locations: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate: InputMaybe<Scalars['String']>;
  topics: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useEventDate: InputMaybe<Scalars['Boolean']>;
};

export type ContentHubListResult = {
  __typename?: 'ContentHubListResult';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  content: Array<ContentHubListResultItem>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
};

export type ContentHubListResultItem = Bulletin | Context | Event | FactSheet | Kernwissen | MultimediaDossier | News | Podcast | PressRelease | TopicCollection | Video;

export type Context = {
  __typename?: 'Context';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Context>;
  body: Array<ContentBlock>;
  contentAuthor: Maybe<BlockHtml>;
  contentSource: Maybe<BlockHtml>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  references: Maybe<BlockLinkList>;
  relatedArticles: Maybe<Array<Maybe<RelatedArticle>>>;
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<Context>;
  video: Maybe<BlockRemoteVideo>;
};

export type CoverBlock = {
  __typename?: 'CoverBlock';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  headline: Maybe<Scalars['String']>;
  image: Maybe<Image>;
  imageCaption: Maybe<Scalars['String']>;
  imageSource: Maybe<Scalars['String']>;
  leadtext: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Event>;
  additionalInformation: Maybe<Scalars['String']>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  endDate: Maybe<Scalars['String']>;
  eventType: Maybe<EventType>;
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  location: Maybe<Scalars['String']>;
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  startDate: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<Event>;
  video: Maybe<BlockRemoteVideo>;
};

export enum EventType {
  Internal = 'internal',
  PublicEvents = 'public_events'
}

export type ExternalNewsletterLinkSettings = {
  __typename?: 'ExternalNewsletterLinkSettings';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  langcode: Scalars['String'];
  path: Scalars['String'];
};

export type FactSheet = {
  __typename?: 'FactSheet';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<FactSheet>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<FactSheet>;
  video: Maybe<BlockRemoteVideo>;
};

export type FooterMenu = Navigation & {
  __typename?: 'FooterMenu';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<FooterMenu>;
  items: Maybe<Array<MenuItem>>;
  langcode: Scalars['String'];
  translations: Array<FooterMenu>;
};

export type Geography = {
  __typename?: 'Geography';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Geography>;
  depth: Scalars['Int'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  langcode: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
  translations: Array<Geography>;
};

export type HomePageSettings = {
  __typename?: 'HomePageSettings';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  headerIntroText: Maybe<Scalars['String']>;
  headerIntroTitle: Maybe<Scalars['String']>;
  heroContent: Maybe<Array<HomepageHeroContent>>;
  langcode: Scalars['String'];
};

export type HomepageHeroContent = Bulletin | Context | Event | FactSheet | MultimediaDossier | News | Podcast | PressRelease | TopicCollection | Video;

export type Image = {
  __typename?: 'Image';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Image>;
  alt: Scalars['String'];
  drupalId: Scalars['String'];
  height: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  langcode: Scalars['String'];
  styles: Array<ImageStyle>;
  translations: Array<Image>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Int']>;
};

export type ImageSource = {
  __typename?: 'ImageSource';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type ImageStyle = {
  __typename?: 'ImageStyle';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  sources: Array<ImageSource>;
};

export type Kernwissen = {
  __typename?: 'Kernwissen';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Kernwissen>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  kernwissenTag: KernwissenTags;
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  pageLayout: PageLayout;
  path: Scalars['String'];
  publishedDate: Scalars['String'];
  rightColumn: Array<BlockHighlight>;
  title: Scalars['String'];
  translations: Array<Kernwissen>;
};

export type KernwissenContentListResult = {
  __typename?: 'KernwissenContentListResult';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  content: Array<ContentHubListResultItem>;
  total: Scalars['Int'];
};

export type KernwissenListInput = {
  filters: InputMaybe<KernwissenListInputFilter>;
  langcode: Scalars['String'];
};

export type KernwissenListInputFilter = {
  kernwissen: InputMaybe<Array<Scalars['String']>>;
};

export type KernwissenTagList = Kernwissen;

export type KernwissenTags = {
  __typename?: 'KernwissenTags';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<KernwissenTags>;
  depth: Scalars['Int'];
  description: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  langcode: Scalars['String'];
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  teaserImage: Maybe<Image>;
  title: Scalars['String'];
  translations: Array<KernwissenTags>;
  weight: Maybe<Scalars['Int']>;
};

export type LinkListItem = {
  __typename?: 'LinkListItem';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  description: Maybe<Scalars['String']>;
  linkText: Scalars['String'];
  linkType: LinkType;
  linkUrl: Scalars['String'];
  openInNewTab: Scalars['Boolean'];
};

export type LinkType = {
  __typename?: 'LinkType';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  isAsset: Scalars['Boolean'];
  isExternal: Scalars['Boolean'];
};

export type MainMenu = Navigation & {
  __typename?: 'MainMenu';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<MainMenu>;
  items: Maybe<Array<MenuItem>>;
  langcode: Scalars['String'];
  translations: Array<MainMenu>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type MetaInformation = {
  __typename?: 'MetaInformation';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  articlePublishedTime: Scalars['String'];
};

export type MetaMenu = Navigation & {
  __typename?: 'MetaMenu';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<MetaMenu>;
  items: Maybe<Array<MenuItem>>;
  langcode: Scalars['String'];
  translations: Array<MetaMenu>;
};

export type MultimediaDossier = {
  __typename?: 'MultimediaDossier';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<MultimediaDossier>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<MultimediaDossier>;
  video: Maybe<BlockRemoteVideo>;
};

export type Navigation = {
  items: Maybe<Array<MenuItem>>;
};

export type News = {
  __typename?: 'News';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<News>;
  body: Array<ContentBlock>;
  contentSource: Maybe<BlockHtml>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  references: Maybe<BlockLinkList>;
  relatedArticles: Maybe<Array<Maybe<RelatedArticle>>>;
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<News>;
  video: Maybe<BlockRemoteVideo>;
};

export type Page = {
  __typename?: 'Page';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Page>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  pageLayout: PageLayout;
  path: Scalars['String'];
  publishedDate: Scalars['String'];
  rightColumn: Array<BlockHighlight>;
  title: Scalars['String'];
  translations: Array<Page>;
};

export enum PageLayout {
  Default = 'DEFAULT',
  HeaderWithBackground = 'HEADER_WITH_BACKGROUND'
}

export type Podcast = {
  __typename?: 'Podcast';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Podcast>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<Podcast>;
  video: Maybe<BlockRemoteVideo>;
};

export type PressRelease = {
  __typename?: 'PressRelease';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<PressRelease>;
  attachments: Maybe<BlockAttachments>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  references: Maybe<BlockLinkList>;
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<PressRelease>;
  video: Maybe<BlockRemoteVideo>;
};

export type PressReleaseSettings = {
  __typename?: 'PressReleaseSettings';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  contactInfo: Scalars['String'];
  contactTitle: Maybe<Scalars['String']>;
  langcode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated Field no longer supported */
  _currentUser: _User;
  /** @deprecated Field no longer supported */
  _drupalBuildId: Scalars['Int'];
  /** @deprecated Field no longer supported */
  _drupalFeedInfo: Array<_Feed>;
  /** @deprecated Field no longer supported */
  _loadBranch: Maybe<Branch>;
  /** @deprecated Field no longer supported */
  _loadBranchRevision: Maybe<Branch>;
  /** @deprecated Field no longer supported */
  _loadBulletin: Maybe<Bulletin>;
  /** @deprecated Field no longer supported */
  _loadBulletinRevision: Maybe<Bulletin>;
  /** @deprecated Field no longer supported */
  _loadCompany: Maybe<Company>;
  /** @deprecated Field no longer supported */
  _loadCompanyRevision: Maybe<Company>;
  /** @deprecated Field no longer supported */
  _loadContext: Maybe<Context>;
  /** @deprecated Field no longer supported */
  _loadContextRevision: Maybe<Context>;
  /** @deprecated Field no longer supported */
  _loadEvent: Maybe<Event>;
  /** @deprecated Field no longer supported */
  _loadEventRevision: Maybe<Event>;
  /** @deprecated Field no longer supported */
  _loadFactSheet: Maybe<FactSheet>;
  /** @deprecated Field no longer supported */
  _loadFactSheetRevision: Maybe<FactSheet>;
  /** @deprecated Field no longer supported */
  _loadFooterMenu: Maybe<FooterMenu>;
  /** @deprecated Field no longer supported */
  _loadGeography: Maybe<Geography>;
  /** @deprecated Field no longer supported */
  _loadGeographyRevision: Maybe<Geography>;
  /** @deprecated Field no longer supported */
  _loadImage: Maybe<Image>;
  /** @deprecated Field no longer supported */
  _loadImageRevision: Maybe<Image>;
  /** @deprecated Field no longer supported */
  _loadKernwissen: Maybe<Kernwissen>;
  /** @deprecated Field no longer supported */
  _loadKernwissenRevision: Maybe<Kernwissen>;
  /** @deprecated Field no longer supported */
  _loadKernwissenTags: Maybe<KernwissenTags>;
  /** @deprecated Field no longer supported */
  _loadKernwissenTagsRevision: Maybe<KernwissenTags>;
  /** @deprecated Field no longer supported */
  _loadMainMenu: Maybe<MainMenu>;
  /** @deprecated Field no longer supported */
  _loadMetaMenu: Maybe<MetaMenu>;
  /** @deprecated Field no longer supported */
  _loadMultimediaDossier: Maybe<MultimediaDossier>;
  /** @deprecated Field no longer supported */
  _loadMultimediaDossierRevision: Maybe<MultimediaDossier>;
  /** @deprecated Field no longer supported */
  _loadNews: Maybe<News>;
  /** @deprecated Field no longer supported */
  _loadNewsRevision: Maybe<News>;
  /** @deprecated Field no longer supported */
  _loadPage: Maybe<Page>;
  /** @deprecated Field no longer supported */
  _loadPageRevision: Maybe<Page>;
  /** @deprecated Field no longer supported */
  _loadPodcast: Maybe<Podcast>;
  /** @deprecated Field no longer supported */
  _loadPodcastRevision: Maybe<Podcast>;
  /** @deprecated Field no longer supported */
  _loadPressRelease: Maybe<PressRelease>;
  /** @deprecated Field no longer supported */
  _loadPressReleaseRevision: Maybe<PressRelease>;
  /** @deprecated Field no longer supported */
  _loadSettings: Maybe<Settings>;
  /** @deprecated Field no longer supported */
  _loadSettingsRevision: Maybe<Settings>;
  /** @deprecated Field no longer supported */
  _loadTopic: Maybe<Topic>;
  /** @deprecated Field no longer supported */
  _loadTopicCollection: Maybe<TopicCollection>;
  /** @deprecated Field no longer supported */
  _loadTopicCollectionRevision: Maybe<TopicCollection>;
  /** @deprecated Field no longer supported */
  _loadTopicRevision: Maybe<Topic>;
  /** @deprecated Field no longer supported */
  _loadVideo: Maybe<Video>;
  /** @deprecated Field no longer supported */
  _loadVideoRevision: Maybe<Video>;
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _queryBranchs: Array<Maybe<Branch>>;
  /** @deprecated Field no longer supported */
  _queryBulletins: Array<Maybe<Bulletin>>;
  /** @deprecated Field no longer supported */
  _queryCompanys: Array<Maybe<Company>>;
  /** @deprecated Field no longer supported */
  _queryContexts: Array<Maybe<Context>>;
  /** @deprecated Field no longer supported */
  _queryEvents: Array<Maybe<Event>>;
  /** @deprecated Field no longer supported */
  _queryFactSheets: Array<Maybe<FactSheet>>;
  /** @deprecated Field no longer supported */
  _queryFooterMenus: Array<Maybe<FooterMenu>>;
  /** @deprecated Field no longer supported */
  _queryGeographys: Array<Maybe<Geography>>;
  /** @deprecated Field no longer supported */
  _queryImages: Array<Maybe<Image>>;
  /** @deprecated Field no longer supported */
  _queryKernwissenTagss: Array<Maybe<KernwissenTags>>;
  /** @deprecated Field no longer supported */
  _queryKernwissens: Array<Maybe<Kernwissen>>;
  /** @deprecated Field no longer supported */
  _queryMainMenus: Array<Maybe<MainMenu>>;
  /** @deprecated Field no longer supported */
  _queryMetaMenus: Array<Maybe<MetaMenu>>;
  /** @deprecated Field no longer supported */
  _queryMultimediaDossiers: Array<Maybe<MultimediaDossier>>;
  /** @deprecated Field no longer supported */
  _queryNewss: Array<Maybe<News>>;
  /** @deprecated Field no longer supported */
  _queryPages: Array<Maybe<Page>>;
  /** @deprecated Field no longer supported */
  _queryPodcasts: Array<Maybe<Podcast>>;
  /** @deprecated Field no longer supported */
  _queryPressReleases: Array<Maybe<PressRelease>>;
  /** @deprecated Field no longer supported */
  _querySettingss: Array<Maybe<Settings>>;
  /** @deprecated Field no longer supported */
  _queryTopicCollections: Array<Maybe<TopicCollection>>;
  /** @deprecated Field no longer supported */
  _queryTopics: Array<Maybe<Topic>>;
  /** @deprecated Field no longer supported */
  _queryVideos: Array<Maybe<Video>>;
  companies: CompaniesListResult;
  listContentHub: ContentHubListResult;
  listContentHubFocus: ContentHubFocusListResult;
  listKernwissen: KernwissenContentListResult;
  user: Scalars['String'];
};


export type Query_LoadBranchArgs = {
  id: Scalars['String'];
};


export type Query_LoadBranchRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadBulletinArgs = {
  id: Scalars['String'];
};


export type Query_LoadBulletinRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadCompanyArgs = {
  id: Scalars['String'];
};


export type Query_LoadCompanyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadContextArgs = {
  id: Scalars['String'];
};


export type Query_LoadContextRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadEventArgs = {
  id: Scalars['String'];
};


export type Query_LoadEventRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadFactSheetArgs = {
  id: Scalars['String'];
};


export type Query_LoadFactSheetRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadFooterMenuArgs = {
  id: Scalars['String'];
};


export type Query_LoadGeographyArgs = {
  id: Scalars['String'];
};


export type Query_LoadGeographyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadImageArgs = {
  id: Scalars['String'];
};


export type Query_LoadImageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadKernwissenArgs = {
  id: Scalars['String'];
};


export type Query_LoadKernwissenRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadKernwissenTagsArgs = {
  id: Scalars['String'];
};


export type Query_LoadKernwissenTagsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadMainMenuArgs = {
  id: Scalars['String'];
};


export type Query_LoadMetaMenuArgs = {
  id: Scalars['String'];
};


export type Query_LoadMultimediaDossierArgs = {
  id: Scalars['String'];
};


export type Query_LoadMultimediaDossierRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadNewsArgs = {
  id: Scalars['String'];
};


export type Query_LoadNewsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadPageArgs = {
  id: Scalars['String'];
};


export type Query_LoadPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadPodcastArgs = {
  id: Scalars['String'];
};


export type Query_LoadPodcastRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadPressReleaseArgs = {
  id: Scalars['String'];
};


export type Query_LoadPressReleaseRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadSettingsArgs = {
  id: Scalars['String'];
};


export type Query_LoadSettingsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadTopicArgs = {
  id: Scalars['String'];
};


export type Query_LoadTopicCollectionArgs = {
  id: Scalars['String'];
};


export type Query_LoadTopicCollectionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadTopicRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_LoadVideoArgs = {
  id: Scalars['String'];
};


export type Query_LoadVideoRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type Query_QueryBranchsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryBulletinsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryCompanysArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryContextsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryEventsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryFactSheetsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryFooterMenusArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryGeographysArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryImagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryKernwissenTagssArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryKernwissensArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryMainMenusArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryMetaMenusArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryMultimediaDossiersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryNewssArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryPagesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryPodcastsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryPressReleasesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QuerySettingssArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryTopicCollectionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryTopicsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type Query_QueryVideosArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type QueryCompaniesArgs = {
  input: CompaniesListInput;
};


export type QueryListContentHubArgs = {
  input: ContentHubListInput;
};


export type QueryListContentHubFocusArgs = {
  input: ContentHubFocusListInput;
};


export type QueryListKernwissenArgs = {
  input: KernwissenListInput;
};

export type RelatedArticle = Bulletin | Context | Event | FactSheet | MultimediaDossier | News | Podcast | PressRelease | TopicCollection | Video;

export type RelatedTopicArticle = Bulletin | Context | Event | FactSheet | MultimediaDossier | News | Podcast | PressRelease | Video;

export type Settings = {
  __typename?: 'Settings';
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  footerTagCloud: Maybe<Array<Topic>>;
  homePage: Maybe<Array<HomePageSettings>>;
  preFooterExternalNewsletterLink: Maybe<Array<Maybe<ExternalNewsletterLinkSettings>>>;
  preFooterMembership: Maybe<Page>;
  preFooterNewsletterSubscription: Maybe<Page>;
  pressRelease: Maybe<Array<PressReleaseSettings>>;
};

export type Topic = {
  __typename?: 'Topic';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Topic>;
  depth: Scalars['Int'];
  description: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  langcode: Scalars['String'];
  modifiedTimestamp: Scalars['String'];
  parentTopic: Maybe<Topic>;
  path: Scalars['String'];
  subTopics: Maybe<Array<Maybe<Topic>>>;
  title: Scalars['String'];
  translations: Array<Topic>;
};

export type TopicCollection = {
  __typename?: 'TopicCollection';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<TopicCollection>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  relatedArticles: Maybe<Array<Maybe<RelatedTopicArticle>>>;
  relatedArticlesCount: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<TopicCollection>;
  video: Maybe<BlockRemoteVideo>;
};

export type Video = {
  __typename?: 'Video';
  /** @deprecated Field no longer supported */
  _defaultTranslation: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  _drupalId: Scalars['String'];
  /** @deprecated Field no longer supported */
  _id: Scalars['String'];
  /** @deprecated Field no longer supported */
  _langcode: Scalars['String'];
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  /** @deprecated Field no longer supported */
  _translations: Array<Video>;
  body: Array<ContentBlock>;
  cover: Maybe<CoverBlock>;
  drupalId: Scalars['String'];
  firstHeroContent: Maybe<Scalars['Boolean']>;
  focus: Maybe<Scalars['Boolean']>;
  geography: Maybe<Array<Maybe<Geography>>>;
  id: Scalars['String'];
  indexableContent: Scalars['String'];
  langcode: Scalars['String'];
  meta: MetaInformation;
  modifiedTimestamp: Scalars['String'];
  path: Scalars['String'];
  promoted: Maybe<Scalars['Boolean']>;
  publishedDate: Scalars['String'];
  publishedTimestamp: Scalars['Int'];
  title: Scalars['String'];
  topics: Array<Topic>;
  translations: Array<Video>;
  video: Maybe<BlockRemoteVideo>;
};

export type _Feed = {
  __typename?: '_Feed';
  /** @deprecated Field no longer supported */
  _original_typename: Scalars['String'];
  changes: Array<Scalars['String']>;
  listFieldName: Scalars['String'];
  pathFieldName: Maybe<Scalars['String']>;
  singleFieldName: Scalars['String'];
  templateFieldName: Maybe<Scalars['String']>;
  translatable: Scalars['Boolean'];
  typeName: Scalars['String'];
};


export type _FeedChangesArgs = {
  currentBuild: InputMaybe<Scalars['Int']>;
  lastBuild: InputMaybe<Scalars['Int']>;
};

export type _User = {
  __typename?: '_User';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type ContentHubListNewsResultFragmentFragment = { __typename?: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListContextResultFragmentFragment = { __typename?: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListPressReleaseResultFragmentFragment = { __typename?: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListVideoResultFragmentFragment = { __typename?: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListFactSheetResultFragmentFragment = { __typename?: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListMultimediaDossierResultFragmentFragment = { __typename?: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListBulletinResultFragmentFragment = { __typename?: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListPodcastResultFragmentFragment = { __typename?: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListEventResultFragmentFragment = { __typename?: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListTopicCollectionResultFragmentFragment = { __typename?: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type KernwissenContentResultFragmentFragment = { __typename?: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> };

export type ContentHubFocusListNewsResultFragmentFragment = { __typename?: 'News', title: string, path: string, publishedDate: string };

export type ContentHubFocusListContextResultFragmentFragment = { __typename?: 'Context', title: string, path: string, publishedDate: string };

export type ContentHubFocusListPressReleaseResultFragmentFragment = { __typename?: 'PressRelease', title: string, path: string, publishedDate: string };

export type ContentHubFocusListVideoResultFragmentFragment = { __typename?: 'Video', title: string, path: string, publishedDate: string };

export type ContentHubFocusListFactSheetResultFragmentFragment = { __typename?: 'FactSheet', title: string, path: string, publishedDate: string };

export type ContentHubFocusListMultimediaDossierResultFragmentFragment = { __typename?: 'MultimediaDossier', title: string, path: string, publishedDate: string };

export type ContentHubFocusListBulletinResultFragmentFragment = { __typename?: 'Bulletin', title: string, path: string, publishedDate: string };

export type ContentHubFocusListPodcastResultFragmentFragment = { __typename?: 'Podcast', title: string, path: string, publishedDate: string };

export type ContentHubFocusListEventResultFragmentFragment = { __typename?: 'Event', title: string, path: string, publishedDate: string };

export type ContentHubFocusListTopicCollectionResultFragmentFragment = { __typename?: 'TopicCollection', title: string, path: string, publishedDate: string };

type ContentHubListResultFragment_Bulletin_Fragment = { __typename: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_Context_Fragment = { __typename: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_Event_Fragment = { __typename: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_FactSheet_Fragment = { __typename: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_Kernwissen_Fragment = { __typename: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> };

type ContentHubListResultFragment_MultimediaDossier_Fragment = { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_News_Fragment = { __typename: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_Podcast_Fragment = { __typename: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_PressRelease_Fragment = { __typename: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_TopicCollection_Fragment = { __typename: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

type ContentHubListResultFragment_Video_Fragment = { __typename: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined };

export type ContentHubListResultFragmentFragment = ContentHubListResultFragment_Bulletin_Fragment | ContentHubListResultFragment_Context_Fragment | ContentHubListResultFragment_Event_Fragment | ContentHubListResultFragment_FactSheet_Fragment | ContentHubListResultFragment_Kernwissen_Fragment | ContentHubListResultFragment_MultimediaDossier_Fragment | ContentHubListResultFragment_News_Fragment | ContentHubListResultFragment_Podcast_Fragment | ContentHubListResultFragment_PressRelease_Fragment | ContentHubListResultFragment_TopicCollection_Fragment | ContentHubListResultFragment_Video_Fragment;

type ContentHubFocusListResultFragment_Bulletin_Fragment = { __typename: 'Bulletin', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_Context_Fragment = { __typename: 'Context', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_Event_Fragment = { __typename: 'Event', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_FactSheet_Fragment = { __typename: 'FactSheet', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_Kernwissen_Fragment = { __typename: 'Kernwissen' };

type ContentHubFocusListResultFragment_MultimediaDossier_Fragment = { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_News_Fragment = { __typename: 'News', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_Podcast_Fragment = { __typename: 'Podcast', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_PressRelease_Fragment = { __typename: 'PressRelease', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_TopicCollection_Fragment = { __typename: 'TopicCollection', title: string, path: string, publishedDate: string };

type ContentHubFocusListResultFragment_Video_Fragment = { __typename: 'Video', title: string, path: string, publishedDate: string };

export type ContentHubFocusListResultFragmentFragment = ContentHubFocusListResultFragment_Bulletin_Fragment | ContentHubFocusListResultFragment_Context_Fragment | ContentHubFocusListResultFragment_Event_Fragment | ContentHubFocusListResultFragment_FactSheet_Fragment | ContentHubFocusListResultFragment_Kernwissen_Fragment | ContentHubFocusListResultFragment_MultimediaDossier_Fragment | ContentHubFocusListResultFragment_News_Fragment | ContentHubFocusListResultFragment_Podcast_Fragment | ContentHubFocusListResultFragment_PressRelease_Fragment | ContentHubFocusListResultFragment_TopicCollection_Fragment | ContentHubFocusListResultFragment_Video_Fragment;

export type CompaniesListResultFragmentFragment = { __typename: 'Company', path: string, companyName: string, city: string | undefined, countryCode: string | undefined, description: string | undefined, logo: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined };

export type ContentHubListResultsFragmentFragment = { __typename?: 'ContentHubListResult', total: number, page: number, itemsPerPage: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined }> };

export type KernwissenContentListResultsFragmentFragment = { __typename?: 'KernwissenContentListResult', total: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined }> };

export type ContentHubFocusListResultsFragmentFragment = { __typename?: 'ContentHubFocusListResult', total: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string } | { __typename: 'Context', title: string, path: string, publishedDate: string } | { __typename: 'Event', title: string, path: string, publishedDate: string } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string } | { __typename: 'Kernwissen' } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string } | { __typename: 'News', title: string, path: string, publishedDate: string } | { __typename: 'Podcast', title: string, path: string, publishedDate: string } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string } | { __typename: 'Video', title: string, path: string, publishedDate: string }> };

export type CompaniesListResultsFragmentFragment = { __typename?: 'CompaniesListResult', total: number, content: Array<{ __typename: 'Company', path: string, companyName: string, city: string | undefined, countryCode: string | undefined, description: string | undefined, logo: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined }> };

export type ContentHubListQueryVariables = Exact<{
  input: ContentHubListInput;
}>;


export type ContentHubListQuery = { __typename?: 'Query', listContentHub: { __typename?: 'ContentHubListResult', total: number, page: number, itemsPerPage: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined }> } };

export type ListKernwissenQueryVariables = Exact<{
  input: KernwissenListInput;
}>;


export type ListKernwissenQuery = { __typename?: 'Query', listKernwissen: { __typename?: 'KernwissenContentListResult', total: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Context', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Event', title: string, path: string, publishedDate: string, startDate: string | undefined, eventType: EventType | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Kernwissen', id: string, title: string, path: string, langcode: string, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined, body: Array<{ __typename?: 'BlockCompaniesList' } | { __typename?: 'BlockCookiePreferencesButton' } | { __typename?: 'BlockDocument' } | { __typename?: 'BlockForm' } | { __typename?: 'BlockHighlight' } | { __typename: 'BlockHtml', html: string } | { __typename?: 'BlockIframe' } | { __typename?: 'BlockImage' } | { __typename?: 'BlockInfoBox' } | { __typename?: 'BlockLinkList' } | { __typename?: 'BlockPodcast' } | { __typename?: 'BlockPodcastButtons' } | { __typename?: 'BlockRemoteVideo' } | { __typename?: 'BlockTeaserList' }> } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'News', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Podcast', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string, relatedArticlesCount: number | undefined, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined } | { __typename: 'Video', title: string, path: string, publishedDate: string, topics: Array<{ __typename?: 'Topic', drupalId: string, title: string, path: string, parentTopic: { __typename?: 'Topic', id: string } | undefined }>, cover: { __typename?: 'CoverBlock', leadtext: string | undefined, image: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined } | undefined }> } };

export type ContentHubFocusListQueryVariables = Exact<{
  input: ContentHubFocusListInput;
}>;


export type ContentHubFocusListQuery = { __typename?: 'Query', listContentHubFocus: { __typename?: 'ContentHubFocusListResult', total: number, content: Array<{ __typename: 'Bulletin', title: string, path: string, publishedDate: string } | { __typename: 'Context', title: string, path: string, publishedDate: string } | { __typename: 'Event', title: string, path: string, publishedDate: string } | { __typename: 'FactSheet', title: string, path: string, publishedDate: string } | { __typename: 'Kernwissen' } | { __typename: 'MultimediaDossier', title: string, path: string, publishedDate: string } | { __typename: 'News', title: string, path: string, publishedDate: string } | { __typename: 'Podcast', title: string, path: string, publishedDate: string } | { __typename: 'PressRelease', title: string, path: string, publishedDate: string } | { __typename: 'TopicCollection', title: string, path: string, publishedDate: string } | { __typename: 'Video', title: string, path: string, publishedDate: string }> } };

export type CompaniesListQueryVariables = Exact<{
  input: CompaniesListInput;
}>;


export type CompaniesListQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesListResult', total: number, content: Array<{ __typename: 'Company', path: string, companyName: string, city: string | undefined, countryCode: string | undefined, description: string | undefined, logo: { __typename?: 'Image', id: string, url: string | undefined, width: number | undefined, height: number | undefined, alt: string, styles: Array<{ __typename?: 'ImageStyle', id: string, sources: Array<{ __typename?: 'ImageSource', url: string, width: number, height: number }> }> } | undefined }> } };

export const ContentHubListNewsResultFragmentFragmentDoc = `
    fragment ContentHubListNewsResultFragment on News {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListContextResultFragmentFragmentDoc = `
    fragment ContentHubListContextResultFragment on Context {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListPressReleaseResultFragmentFragmentDoc = `
    fragment ContentHubListPressReleaseResultFragment on PressRelease {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListVideoResultFragmentFragmentDoc = `
    fragment ContentHubListVideoResultFragment on Video {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListBulletinResultFragmentFragmentDoc = `
    fragment ContentHubListBulletinResultFragment on Bulletin {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListFactSheetResultFragmentFragmentDoc = `
    fragment ContentHubListFactSheetResultFragment on FactSheet {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListMultimediaDossierResultFragmentFragmentDoc = `
    fragment ContentHubListMultimediaDossierResultFragment on MultimediaDossier {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListPodcastResultFragmentFragmentDoc = `
    fragment ContentHubListPodcastResultFragment on Podcast {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListEventResultFragmentFragmentDoc = `
    fragment ContentHubListEventResultFragment on Event {
  title
  path
  publishedDate
  startDate
  eventType
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
}
    `;
export const ContentHubListTopicCollectionResultFragmentFragmentDoc = `
    fragment ContentHubListTopicCollectionResultFragment on TopicCollection {
  title
  path
  publishedDate
  topics {
    drupalId
    title
    path
    parentTopic {
      id
    }
  }
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
  relatedArticlesCount
}
    `;
export const KernwissenContentResultFragmentFragmentDoc = `
    fragment KernwissenContentResultFragment on Kernwissen {
  id
  title
  cover {
    leadtext
    image {
      id
      url
      width
      height
      styles {
        id
        sources {
          url
          width
          height
        }
      }
      alt
    }
  }
  body {
    ... on BlockHtml {
      __typename
      html
    }
  }
  path
  langcode
}
    `;
export const ContentHubListResultFragmentFragmentDoc = `
    fragment ContentHubListResultFragment on ContentHubListResultItem {
  __typename
  ...ContentHubListNewsResultFragment
  ...ContentHubListContextResultFragment
  ...ContentHubListPressReleaseResultFragment
  ...ContentHubListVideoResultFragment
  ...ContentHubListBulletinResultFragment
  ...ContentHubListFactSheetResultFragment
  ...ContentHubListMultimediaDossierResultFragment
  ...ContentHubListPodcastResultFragment
  ...ContentHubListEventResultFragment
  ...ContentHubListTopicCollectionResultFragment
  ...KernwissenContentResultFragment
}
    ${ContentHubListNewsResultFragmentFragmentDoc}
${ContentHubListContextResultFragmentFragmentDoc}
${ContentHubListPressReleaseResultFragmentFragmentDoc}
${ContentHubListVideoResultFragmentFragmentDoc}
${ContentHubListBulletinResultFragmentFragmentDoc}
${ContentHubListFactSheetResultFragmentFragmentDoc}
${ContentHubListMultimediaDossierResultFragmentFragmentDoc}
${ContentHubListPodcastResultFragmentFragmentDoc}
${ContentHubListEventResultFragmentFragmentDoc}
${ContentHubListTopicCollectionResultFragmentFragmentDoc}
${KernwissenContentResultFragmentFragmentDoc}`;
export const ContentHubListResultsFragmentFragmentDoc = `
    fragment ContentHubListResultsFragment on ContentHubListResult {
  total
  page
  itemsPerPage
  content {
    ...ContentHubListResultFragment
  }
}
    ${ContentHubListResultFragmentFragmentDoc}`;
export const KernwissenContentListResultsFragmentFragmentDoc = `
    fragment KernwissenContentListResultsFragment on KernwissenContentListResult {
  total
  content {
    ...ContentHubListResultFragment
  }
}
    ${ContentHubListResultFragmentFragmentDoc}`;
export const ContentHubFocusListNewsResultFragmentFragmentDoc = `
    fragment ContentHubFocusListNewsResultFragment on News {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListContextResultFragmentFragmentDoc = `
    fragment ContentHubFocusListContextResultFragment on Context {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListPressReleaseResultFragmentFragmentDoc = `
    fragment ContentHubFocusListPressReleaseResultFragment on PressRelease {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListVideoResultFragmentFragmentDoc = `
    fragment ContentHubFocusListVideoResultFragment on Video {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListBulletinResultFragmentFragmentDoc = `
    fragment ContentHubFocusListBulletinResultFragment on Bulletin {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListFactSheetResultFragmentFragmentDoc = `
    fragment ContentHubFocusListFactSheetResultFragment on FactSheet {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListMultimediaDossierResultFragmentFragmentDoc = `
    fragment ContentHubFocusListMultimediaDossierResultFragment on MultimediaDossier {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListPodcastResultFragmentFragmentDoc = `
    fragment ContentHubFocusListPodcastResultFragment on Podcast {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListEventResultFragmentFragmentDoc = `
    fragment ContentHubFocusListEventResultFragment on Event {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListTopicCollectionResultFragmentFragmentDoc = `
    fragment ContentHubFocusListTopicCollectionResultFragment on TopicCollection {
  title
  path
  publishedDate
}
    `;
export const ContentHubFocusListResultFragmentFragmentDoc = `
    fragment ContentHubFocusListResultFragment on ContentHubListResultItem {
  __typename
  ...ContentHubFocusListNewsResultFragment
  ...ContentHubFocusListContextResultFragment
  ...ContentHubFocusListPressReleaseResultFragment
  ...ContentHubFocusListVideoResultFragment
  ...ContentHubFocusListBulletinResultFragment
  ...ContentHubFocusListFactSheetResultFragment
  ...ContentHubFocusListMultimediaDossierResultFragment
  ...ContentHubFocusListPodcastResultFragment
  ...ContentHubFocusListEventResultFragment
  ...ContentHubFocusListTopicCollectionResultFragment
}
    ${ContentHubFocusListNewsResultFragmentFragmentDoc}
${ContentHubFocusListContextResultFragmentFragmentDoc}
${ContentHubFocusListPressReleaseResultFragmentFragmentDoc}
${ContentHubFocusListVideoResultFragmentFragmentDoc}
${ContentHubFocusListBulletinResultFragmentFragmentDoc}
${ContentHubFocusListFactSheetResultFragmentFragmentDoc}
${ContentHubFocusListMultimediaDossierResultFragmentFragmentDoc}
${ContentHubFocusListPodcastResultFragmentFragmentDoc}
${ContentHubFocusListEventResultFragmentFragmentDoc}
${ContentHubFocusListTopicCollectionResultFragmentFragmentDoc}`;
export const ContentHubFocusListResultsFragmentFragmentDoc = `
    fragment ContentHubFocusListResultsFragment on ContentHubFocusListResult {
  total
  content {
    ...ContentHubFocusListResultFragment
  }
}
    ${ContentHubFocusListResultFragmentFragmentDoc}`;
export const CompaniesListResultFragmentFragmentDoc = `
    fragment CompaniesListResultFragment on Company {
  __typename
  path
  logo {
    id
    url
    width
    height
    styles {
      id
      sources {
        url
        width
        height
      }
    }
    alt
  }
  companyName
  city
  countryCode
  description
}
    `;
export const CompaniesListResultsFragmentFragmentDoc = `
    fragment CompaniesListResultsFragment on CompaniesListResult {
  total
  content {
    ...CompaniesListResultFragment
  }
}
    ${CompaniesListResultFragmentFragmentDoc}`;
export const ContentHubListDocument = `
    query contentHubList($input: ContentHubListInput!) {
  listContentHub(input: $input) {
    ...ContentHubListResultsFragment
  }
}
    ${ContentHubListResultsFragmentFragmentDoc}`;
export const useContentHubListQuery = <
      TData = ContentHubListQuery,
      TError = unknown
    >(
      variables: ContentHubListQueryVariables,
      options?: UseQueryOptions<ContentHubListQuery, TError, TData>
    ) =>
    useQuery<ContentHubListQuery, TError, TData>(
      ['contentHubList', variables],
      fetcher<ContentHubListQuery, ContentHubListQueryVariables>(ContentHubListDocument, variables),
      options
    );
export const ListKernwissenDocument = `
    query listKernwissen($input: KernwissenListInput!) {
  listKernwissen(input: $input) {
    ...KernwissenContentListResultsFragment
  }
}
    ${KernwissenContentListResultsFragmentFragmentDoc}`;
export const useListKernwissenQuery = <
      TData = ListKernwissenQuery,
      TError = unknown
    >(
      variables: ListKernwissenQueryVariables,
      options?: UseQueryOptions<ListKernwissenQuery, TError, TData>
    ) =>
    useQuery<ListKernwissenQuery, TError, TData>(
      ['listKernwissen', variables],
      fetcher<ListKernwissenQuery, ListKernwissenQueryVariables>(ListKernwissenDocument, variables),
      options
    );
export const ContentHubFocusListDocument = `
    query contentHubFocusList($input: ContentHubFocusListInput!) {
  listContentHubFocus(input: $input) {
    ...ContentHubFocusListResultsFragment
  }
}
    ${ContentHubFocusListResultsFragmentFragmentDoc}`;
export const useContentHubFocusListQuery = <
      TData = ContentHubFocusListQuery,
      TError = unknown
    >(
      variables: ContentHubFocusListQueryVariables,
      options?: UseQueryOptions<ContentHubFocusListQuery, TError, TData>
    ) =>
    useQuery<ContentHubFocusListQuery, TError, TData>(
      ['contentHubFocusList', variables],
      fetcher<ContentHubFocusListQuery, ContentHubFocusListQueryVariables>(ContentHubFocusListDocument, variables),
      options
    );
export const CompaniesListDocument = `
    query companiesList($input: CompaniesListInput!) {
  companies(input: $input) {
    ...CompaniesListResultsFragment
  }
}
    ${CompaniesListResultsFragmentFragmentDoc}`;
export const useCompaniesListQuery = <
      TData = CompaniesListQuery,
      TError = unknown
    >(
      variables: CompaniesListQueryVariables,
      options?: UseQueryOptions<CompaniesListQuery, TError, TData>
    ) =>
    useQuery<CompaniesListQuery, TError, TData>(
      ['companiesList', variables],
      fetcher<CompaniesListQuery, CompaniesListQueryVariables>(CompaniesListDocument, variables),
      options
    );